import { useEffect } from 'react';
import { useRoutes, useLocation, RouteObject } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routePaths } from './routes/paths';
import { routeElements } from './routes/config';
import { initGA4 } from './config/ga4';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });

        if (window.gtag) {
          window.gtag('event', 'hash_navigation', {
            hash: hash,
            page_path: pathname + hash,
            language: i18n.language,
          });
        }
      }
    } else {
      window.scrollTo(0, 0);
    }

    const timer = setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_path: pathname,
          page_title: document.title,
          language: i18n.language,
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname, hash, i18n.language]);

  return null;
};

export const App = () => {
  useEffect(() => {
    initGA4();
  }, []);

  const routes: RouteObject[] = routePaths.map((path) => ({
    path,
    element: routeElements[path],
  }));

  const routing = useRoutes(routes);

  return (
    <>
      <ScrollToTop />
      {routing}
    </>
  );
};